module.exports = __webpack_public_path__ + "media/images/como_funciona/order-5d64fdf201fd3def14b70179691ae0ba.png";